import * as d3 from 'd3';
import moment from 'moment';

/**
 * format the trimmed dataset for use in chart
 * @param {String} year
 * @param color
 * @param {Array} trimmedData
 * @returns {Object}
 */
const formatDataset = (year, color, trimmedData) => {
    const dataset = {
        type: 'line',
        label: year,
        borderColor: color(year),
        backgroundColor: color(year),
        borderWidth: 2,
        fill: false,
        // steppedLine: 'before',
        pointRadius: 0,
        pointHitRadius: 1,
        data: trimmedData.map(d => (
            {
                x: d.d,
                y: d.v,
            }
        )),
    };
    return dataset;
};

/**
 * trim the years data to the appropriate period
 * @param {Moment} periodStart
 * @param {Moment} periodEnd
 * @param {Array} dataYears
 * @return {Array}
 */
const trimArrayToPeriod = (periodStart, periodEnd, dataYears) => {
    const startIndex = dataYears.findIndex(e => e.d.isSame(periodStart));
    const endIndex = dataYears.findIndex(e => e.d.isSame(periodEnd));
    return dataYears.slice(startIndex, endIndex);
};

/**
 * get the period end, it is different if interval is month or day
 * @param {String} interval
 * @param {Moment} periodStart
 * @return {Moment}
 */
function getPeriodEnd(interval, periodStart) {
    if (interval === 'm') {
        return periodStart.clone()
            .add(19, 'months');
    }
    return periodStart.clone()
        .add(19, 'months')
        .subtract(1, 'days');
}

/**
 * format 365-day yearly data into 18-month chart datasets
 * @param {Object} yearlyData
 * @param {Array} yearsSelected
 * @param {Function} formatterFunc
 * @param {String} interval
 * @param {Boolean} mss "true" if the datasets need to be split as per Manual Snow Surveys
 * @return {Array} formatted chart.js datasets
 */
export default (yearlyData, yearsSelected, formatterFunc, interval, mss = false) => {
    const formattedDatasets = [];
    const lastYear = moment().subtract(1, 'years').get('year');
    const color = d3.scaleOrdinal(d3.schemeCategory10);
    // add data that is both selected and downloaded
    const yearsToAdd = Object.keys(yearlyData).filter(e => yearsSelected.includes(parseInt(e, 10)));
    yearsToAdd.forEach((year) => {
        // format data with date objects
        // the first of this month, last year
        const currentMonth = moment().format('MM');
        const periodStart = moment(`${lastYear}-${currentMonth}-01`);

        // period start + 19 months, - 1 day (end of 18 months later)
        const periodEnd = getPeriodEnd(interval, periodStart);

        const singleYearData = yearlyData[year];
        const yearStart = moment(`${lastYear}-01-01`);
        const formattedData = formatterFunc(singleYearData, yearStart);
        // trim the array to just this 18-month period
        const trimmedData = trimArrayToPeriod(periodStart, periodEnd, formattedData);

        if (interval === 'm') {
            // make the line graphs peaks and valleys fall in the "middle" of the month
            // because they are being overlaid on bar charts.
            // 15 technically isn't the exact middle but it's good enough.
            trimmedData.forEach((v) => {
                v.d.add(15, 'days');
            });
        }

        if (mss) {
            // excise the contiguous dates for July 1 (61) to October 31 (183)
            formattedDatasets.push(formatDataset(year, color, trimmedData.splice(0, 61)));
            formattedDatasets.push(formatDataset(year, color, trimmedData.splice(183)));
        } else {
            // create chart.js dataset
            formattedDatasets.push(formatDataset(year, color, trimmedData));
        }
    });

    return formattedDatasets;
};



// WEBPACK FOOTER //
// ./src/functions/formatYearlyData.js